import React from 'react'
import {Button, IconButton, Card, Grid, Box, Typography} from '@material-ui/core'
import {FaRegFileAlt} from 'react-icons/fa'
import TableActions from '../BarcodeLibraryTableActions'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryGridView.styles'

export default function BarcodeLibraryGridView(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [hideView, setHideView] = React.useState(false)
  const _ = require('lodash')

  function handleChangeHide(event) {
    setHideView(hideView ? false : true)
  }

  function displaySecondData(data) {
    if (props.showTable === 'automated' || props.showTable === 'fieldValue') {
      return data.label.name
    } else if (props.showTable === 'sheets') {
      return data.size
    } else {
      return ' '
    }
  }

  function displayThirdData(data) {
    if (props.showTable === 'automated') {
      return data.digits
    } else if (props.showTable === 'fieldValue') {
      return data.entityName
    } else if (props.showTable === 'sheets') {
      return data.rows
    } else {
      return data.width
    }
  }

  function displayFourthData(data) {
    if (props.showTable === 'automated') {
      return data.lastPrinted
    } else if (props.showTable === 'fieldValue') {
      return data.fieldName
    } else if (props.showTable === 'sheets') {
      return data.columns
    } else {
      return data.height
    }
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Typography variant="h4">{props.viewTitle}</Typography>
        <Box>
          <Button
            color="primary"
            className={classes.buttonStyle}
            onClick={e => handleChangeHide(e)}
          >
            {hideView ? t('barcode.library.grid-view.show') : t('barcode.library.grid-view.hide')}
          </Button>
        </Box>
      </Grid>
      <Box marginTop={2} />

      <Grid container hidden={hideView}>
        {props.record.map(data => {
          return (
            <div key={data.id}>
              <Card className={classes.cardStyle}>
                <Box margin={(1, 1, 1, 1)} minHeight={200} maxHeight={200}>
                  <Grid container>
                    <Grid item container xs={6} justify="flex-start">
                      <IconButton
                        size="small"
                        disabled
                        classes={{
                          root: classes.button,
                          disabled: classes.buttonDisabled,
                        }}
                      >
                        <FaRegFileAlt />
                      </IconButton>
                    </Grid>
                    <Grid item container xs={6} justify="flex-end">
                      <TableActions
                        showTable={props.showTable}
                        labelsRecord={props.labelsRecord}
                        record={data}
                        accountId={data.accountId}
                        tableView="gridview"
                      />
                    </Grid>
                  </Grid>
                  <Box marginBottom={1} />
                  <div className={classes.nameStyle}>
                    {_.truncate(data.name, {
                      length: 15,
                      omission: '...',
                    })}
                  </div>
                  <Box marginBottom={2} />
                  <div className={classes.labelStyle}>
                    {_.truncate(displaySecondData(data), {
                      length: 15,
                      omission: '...',
                    })}
                  </div>
                  <Box marginBottom={2} />
                  <Grid container>
                    <Grid item container xs={6} justify="flex-start">
                      <p className={classes.truncate}>{displayThirdData(data)}</p>
                    </Grid>
                    <Grid item container xs={6} justify="flex-start">
                      <p className={classes.truncate}>{displayFourthData(data)}</p>
                    </Grid>
                    <Grid item xs={6}>
                      <p className={classes.numberStyle}>{props.itemOne}</p>
                    </Grid>
                    <Grid item xs={6}>
                      <p className={classes.numberStyle}>{props.itemTwo}</p>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </div>
          )
        })}
      </Grid>
    </div>
  )
}
